import React, { useState } from 'react'
import _ from 'lodash'
import { FlexibleXYPlot, VerticalBarSeries, XAxis, YAxis, HorizontalBarSeries, Crosshair } from 'react-vis'
import { Box, Typography } from '@material-ui/core'
import { useStyle } from './styles'

function Graph(props) {
  const classes = useStyle()
  const [crossHairValues, setCrossHairValues] = useState([])
  const eventType = _.get(props.eventDetails, 'type', '')

  const axisStyle = {
    line: { stroke: '#7b8793' },
    ticks: {
      fontSize: '10px',
      fill: '#a1aab3',
    },
    title: {
      fontSize: '10px',
      fill: '#7b8793',
    },
    tickLine: {
      fill: 'red'
    },
    textAnchor: 'middle'
  }

  const getGraphDetails = (params) => {
    return {
      ...params
    }
  }

  const onNearestX = (value, event) => {
    setCrossHairValues([value])
  }


  const renderVerticalBarSeries = (params) => {
    const graphDetails = getGraphDetails(params)
    return <VerticalBarSeries {...graphDetails} onNearestX={onNearestX} style={{ position: 'relative' }} />
  }

  const renderHorizontalBarSeries = (params) => {
    const graphDetails = getGraphDetails(params)
    return <HorizontalBarSeries {...graphDetails} onNearestX={onNearestX} style={{ position: 'relative' }} />
  }

  const onMouseLeave = () => {
    setCrossHairValues([])
  }

  return (
    <Box className={classes.root} style={{ height: props.height, width: props.width, position: 'relative' }}>
      <Typography className={classes.graphTitle}>{_.get(props.data, 'title', '')}</Typography>
      <FlexibleXYPlot {...(_.get(props.data, 'plot', {}))} onMouseLeave={onMouseLeave}>
        <XAxis style={axisStyle} {...(_.get(props.data, 'xAxis', {}))} />
        <YAxis
          style={axisStyle}
          {...(_.get(props.data, 'yAxis', {}))}
        />
        {_.get(props.data, 'graphsData', []).map(obj => (
          obj.series === 'horizontal'
            ? renderHorizontalBarSeries(obj)
            : renderVerticalBarSeries(obj)
        ))}
        <Crosshair values={crossHairValues} className={classes.crossHair}>
          <Box className={classes.customBox}>
            {
              crossHairValues.map(obj => {
                const val = obj.y ? Math.round((obj.y) * 100) / 100 : 0
                return (
                  eventType === 'BATTERY_DISCHARGE'
                    ? (
                      <Typography>
                        Energy Discharged<span>{` = ${val} kWh`}</span>
                      </Typography>
                    )
                    : (
                      <Typography>
                        Energy Charged<span>{` = ${val} kWh`}</span>
                      </Typography>
                    )
                )
              })
            }
          </Box>
        </Crosshair>
      </FlexibleXYPlot>
    </Box >
  )
}

Graph.defaultProps = {
  data: {},
  eventDetails: {},
  height: '200px',
  width: '100%'
}

export default Graph
